<script>
import axios from 'axios'
import _ from 'underscore'

export default {
    install (Vue, options) {
        const that = this

        // Error handler for both GET and POST requests
        function handleError (error) {
            // Catch unauthorized
            if (error.response && error.response.status == 401) {
                window.store.commit('logout')

                if (window.router) {
                    window.router.push('/login')
                } else {
                    document.location.href = 'login.html'
                }

                // Return promise that is never completed
                return new Promise(function() { })
            // Catch weird errors
            } else if (!error.response || !error.response.status == 422) {
                console.error(error)

                // Access flash plugin on window (initialized in main.js)
                window.flash('Es ist ein Fehler aufgetreten', 'error')
            }

            throw error
        }

        Vue.prototype.$api = {
            get (path, data = {}) {
                if (window.store.state.user !== null) {
                    data = _.extend(data, { api_token: window.store.state.user.api_token })
                }

                return axios.get(window.API_ENDPOINT + path, { 
                    params: data
                }).catch(handleError)
            },
            post (path, data = {}) {
                if (window.store.state.user !== null) {
                    if (data instanceof FormData) {
                        data.append('api_token', window.store.state.user.api_token)
                    } else {
                         data = _.extend(data, { api_token: window.store.state.user.api_token })
                    }
                }

                return axios.post(window.API_ENDPOINT + path, data)
                    .catch(handleError)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// api.vue?0962930c